import React, { Component } from 'react';
import { getSynthCityStats } from '../service/synthwsao'
import '@fortawesome/fontawesome-free/css/all.css'

class Funfacts extends Component {

    constructor(props) {
        super(props)

        this.state = {
            synthRecipes: 0,
            linesOfCode: 0,
            synthCitizens: 0,
            totalDownloads: 0,
            cupsOfCoffee: 0
        }
    }

    componentWillMount() {
        getSynthCityStats().then(stats => this.setState(stats))
    }

    render() {

        var credit = <a style={{ backgroundColor: 'black', color: 'white', textDecoration: 'none', padding: '4px 6px', fontFamily: 'poppins, -apple-system, BlinkMacSystemFont, "San Francisco", "Helvetica Neue", Helvetica, Ubuntu, Roboto, Noto, "Segoe UI", Arial, sans-serif', fontSize: '12px', lineHeight: '1.2', display: 'inline-block', borderRadius: '3px', zIndex: 9999, marginTop: '-27px', position: 'absolute' }} href="https://unsplash.com/@ericjamesward?utm_medium=referral&utm_campaign=photographer-credit&utm_content=creditBadge" target="_blank" rel="noopener noreferrer" title="Download free do whatever you want high-resolution photos from Eric Ward"><span style={{ display: 'inline-block', padding: '2px 3px' }}><svg xmlns="http://www.w3.org/2000/svg" style={{ height: '12px', width: 'auto', position: 'relative', verticalAlign: 'middle', top: '-2px', fill: 'white' }} viewBox="0 0 32 32"><title>unsplash-logo</title><path d="M10 9V0h12v9H10zm12 5h10v18H0V14h10v9h12v-9z" /></svg></span><span style={{ display: 'inline-block', padding: '2px 3px' }}>Eric Ward</span></a>
        return (
            <div>
                <section id="fun-facts">
                    <div className="container">
                        <div className="row">

                            <div className="col-lg-3 col-md-6">
                                <div className="fun-fact-block text-center">
                                    <h2 className="count" data-from={0} data-to={this.state.synthCitizens} data-speed={2500}>{this.state.synthCitizens}</h2>
                                    <span className="fact-icon"><i className="fas fa-user-astronaut" /></span>
                                    <p>synthCitizens</p>
                                </div>
                            </div>{/* END col-lg-3 col-md-6*/}
                            <div className="col-lg-3 col-md-6">
                                <div className="fun-fact-block text-center">
                                    <h2 className="count" data-from={0} data-to={this.state.totalDownloads} data-speed={2500}>{this.state.totalDownloads}</h2>
                                    <span className="fact-icon"><i className="fas fa-cloud-download-alt"></i></span>
                                    <p>Preset Downloads</p>
                                </div>
                            </div> {/* END col-lg-3 col-md-6*/}
                            <div className="col-lg-3 col-md-6">
                                <div className="fun-fact-block text-center">
                                    <h2 className="count" data-from={0} data-to={this.state.linesOfCode} data-speed={1500}>{this.state.linesOfCode}</h2>
                                    <span className="fact-icon"><i className="fa fa-code" /></span>
                                    <p>Lines of Code</p>
                                </div>
                            </div> {/* END col-lg-3 col-md-6*/}
                            <div className="col-lg-3 col-md-6">
                                <div className="fun-fact-block text-center">
                                    <h2 className="count" data-from={0} data-to={this.state.cupsOfCoffee} data-speed={2500}>{this.state.cupsOfCoffee}</h2>
                                    <span className="fact-icon"><i className="fa fa-coffee" /></span>
                                    <p>Coffees Consumed</p>
                                </div>
                            </div> {/* END col-lg-3 col-md-6*/}
                        </div> {/* END row*/}
                    </div> {/* END container*/}
                </section> {/* END fun-facts*/}{credit}
            </div>
        );
    }
}

export default Funfacts;


// WEBPACK FOOTER //
// ./src/components/synthcity/landing/Funfacts.js